export const AUTH_KEYS = {
  REDUCER: 'auth',
  AUTHENTICATED: 'authenticated',
  SIGNED_OUT: 'signedOut',

  ACCESS_TOKEN: 'accessToken',
  LICENSE_STATUS: 'license_status',
}
